import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonItem, 
	IonLabel, IonList, IonRow, IonSearchbar, IonSelect, IonSelectOption, IonModal, 
	IonTitle, IonAlert,
	IonButtons,
	IonToolbar} from '@ionic/react';
import './ExploreContainer.css';
import { locationOutline, navigateOutline, save, search } from 'ionicons/icons';
import { useRef, useState } from 'react';
import { useHistory } from "react-router-dom";

interface ContainerProps { }

const ExploreContainer: React.FC<ContainerProps> = () => {

	const history = useHistory();

	const propertyTypes = [
		{
			id: 1,
			label: 'House',
			name: 'HOUSE',
		},
		{
			id: 2,
			label: 'Land',
			name: 'LAND',
		},
		{
			id: 3,
			label: 'Business',
			name: 'BUSINESS',
		}
	];

	const advertisementTypes = [
		{
			id: 1,
			name: 'sale',
			label: 'For Sale'
		},
		{
			id: 2,
			name: 'rent',
			label: 'For Rent'
		},
	];

	const compareWith = (o1: any, o2: any) => {
		if (!o1 || !o2) {
			return o1 === o2;
		}

		if (Array.isArray(o2)) {
			return o2.some((o) => o.id === o1.id);
		}

		return o1 === o2;
	};

	const [propertyType, setPropertyType] = useState();

	const [adType, setAdType] = useState<string | undefined>(undefined);

	const [location, setLocation] = useState();

	const [message, setMessage] = useState<any>("");

	const [iserror, setIserror] = useState<boolean>(false);

	const [isTypeAlertOpen, setIsTypeAlertOpen] = useState(false);

	function enterSearch() {

		if (!adType) {
			setIsTypeAlertOpen(true);
			return;
		}

		setMessage(null);

		history.push('/map/'+adType);

	}

	return (
		<div className="container">
			<IonGrid className="ion-padding">
				<IonAlert
					isOpen={isTypeAlertOpen}
					header="Rentals or Sales?"
					buttons={[
						{
							text: 'Cancel',
							role: 'cancel',
							handler: () => {
							  
							},
						  },
						  {
							text: 'OK',
							role: 'confirm',
							handler: () => {
							  	if(adType)
									enterSearch();
							  else {
									setMessage("Please select Renting or Buying option!");
									setIserror(true);
							  }
							},
						  },
					]}
					inputs={[
						{
						  	label: 'For Sale',
						  	type: 'radio',
							value: 'sale',
							checked: adType === 'sale',
						  	handler: () => {
								setAdType('sale');
						  }
						},
						{
							label: "For Rent",
							type: "radio",
							value: "rent",
							checked: adType === 'rent',
							handler: () => {
								setAdType('rent');
							}
						}
					  ]}
					onDidDismiss={() => setIsTypeAlertOpen(false)}
				></IonAlert>

				<IonRow className="ion-hide-md-down">
					<IonCol size="1"></IonCol>
					<IonCol size="8">
						<IonRow>
							<IonCol>
								<IonLabel color="danger">{message}</IonLabel>
							</IonCol>
						</IonRow>
						<IonRow>
							<IonCol size='6'>
								<IonList>
									<IonItem>
										<IonSelect
											label="Renting or Buying?"
											interface="popover"
											placeholder="Select One"
											compareWith={compareWith}
											value={adType} onIonChange={(e) => setAdType(e.target.value)}>
											{advertisementTypes.map((type) => (
												<IonSelectOption key={type.name} value={type.name}>
													{type.label}
												</IonSelectOption>
											))}
										</IonSelect>
									</IonItem>
								</IonList>
							</IonCol>
							<IonCol size='6'>
								<IonList>
									<IonItem>
										<IonSelect
											disabled
											label="What are you looking for?"
											interface="popover"
											placeholder="Select Property"
											value={propertyType} onIonChange={(e) => setPropertyType(e.target.value)}>
											{propertyTypes.map((type) => (
												<IonSelectOption key={type.name} value={type.name} >
													{type.label}
												</IonSelectOption>
											))}
										</IonSelect>
									</IonItem>
								</IonList>
							</IonCol>
						</IonRow>
						<IonRow>
							<IonCol size="12">
								<IonItem>
									<IonIcon icon={locationOutline} color="drukre" />
									<IonSearchbar disabled showCancelButton="focus" placeholder="Location" value=""></IonSearchbar>
								</IonItem>
							</IonCol>
						</IonRow>
					</IonCol>
					<IonCol size='2' className="ion-align-self-center">
						<IonButton color="drukre" size="large" onClick={() => enterSearch()}>
							<IonIcon icon={search} />&nbsp;
							Search
						</IonButton>
					</IonCol>
				</IonRow>

				<IonRow className="ion-hide-md-up">
					<IonCol>
						<IonLabel color="danger">{message}</IonLabel>
					</IonCol>
				</IonRow>

				<IonRow className="ion-hide-md-up">
					<IonCol size='12'>
						<IonList>
							<IonItem>
								<IonSelect
									label="Type"
									interface="popover"
									placeholder="Select Type"
									compareWith={compareWith}
									value={adType} onIonChange={(e) => setAdType(e.target.value)}>
									{advertisementTypes.map((type) => (
										<IonSelectOption key={type.name} value={type.name}>
											{type.label}
										</IonSelectOption>
									))}
								</IonSelect>
							</IonItem>
						</IonList>
					</IonCol>
				</IonRow>

				<IonRow className="ion-hide-md-up">
					<IonCol size='12'>
						<IonList>
							<IonItem>
								<IonSelect
									label="What are you looking for?"
									interface="popover"
									disabled
									placeholder="Select Property"
									compareWith={compareWith}
									value={propertyType} onIonChange={(e) => setPropertyType(e.target.value)}>
									{propertyTypes.map((type) => (
										<IonSelectOption key={type.name} value={type.name} >
											{type.label}
										</IonSelectOption>
									))}
								</IonSelect>
							</IonItem>
						</IonList>
					</IonCol>
				</IonRow>

				<IonRow className="ion-hide-md-up">
					<IonCol size="12">
						<IonItem>
							<IonIcon icon={locationOutline} color="drukre" />
							<IonSearchbar disabled showCancelButton="focus" placeholder="Location" value=""></IonSearchbar>
						</IonItem>
					</IonCol>
					<IonCol>
						<IonButton color="drukre" onClick={() => enterSearch()} size="large">
							<IonIcon icon={search} />&nbsp;
							Search
						</IonButton>
					</IonCol>
				</IonRow>
			</IonGrid>
		</div>
	);
};

export default ExploreContainer;
